
import { defineComponent } from 'vue'
import background from '@/assets/images/home/dashboard-background.png'
export default defineComponent({
  components: {
  },
  setup() {
    return {
      background
    }
  }
})
